import { render } from "./RecordTranslator.vue?vue&type=template&id=3bc028b4"
import script from "./RecordTranslator.vue?vue&type=script&lang=ts"
export * from "./RecordTranslator.vue?vue&type=script&lang=ts"

import "./RecordTranslator.vue?vue&type=style&index=0&id=3bc028b4&lang=scss"
script.render = render

export default script